import { BaseModal, ModalResultType } from "./index";
import ViewRendeder from "../view/renderer";
import { BaseApp } from "../app";
import * as Dom from '../helpers/dom';
import { ViewEvent } from "../view/index";

export default class ModalManager
{
    private queue: BaseModal[];
    private app: BaseApp;
    private containerElement: HTMLElement;
    private waitingForNext: boolean;

    private currentModal?: BaseModal;
    
    constructor(app: BaseApp)
    {
        this.app = app;
        this.queue = [];
        this.waitingForNext = false;
        this.containerElement = <HTMLElement>document.querySelector('[data-modal-container]');
    }

    private modalUnloaded = () =>
    {
        Dom.emptyElement(this.containerElement);
        this.next();
    };

    private next()
    {
        if (this.queue.length > 0)
        {
            this.containerElement.classList.add('active');
            this.currentModal = this.queue.shift();
            this.currentModal.on(ViewEvent.UNLOAD, this.modalUnloaded);
            this.containerElement.appendChild(this.currentModal.element);
        }
        else
        {
            this.currentModal = null;
            this.waitingForNext = false;
            this.containerElement.classList.remove('active');
        }
    }

    public closeCurrent(modal: BaseModal): PromiseLike<any>
    {
        if (this.currentModal) {
            return this.currentModal.close();
        } else {
            return Promise.resolve();
        }
    }

    public closeAll()
    {
        if (this.currentModal) {
            this.currentModal.close(ModalResultType.CANCEL).then(() => {
                this.currentModal = null;
                this.closeAll();
            });
            return;
        }

        this.queue.length = 0;
        this.waitingForNext = false;
        this.containerElement.classList.remove('active');
    }

    public show(modal: BaseModal): PromiseLike<void>
    {   
        return new Promise<void>((resolve, reject) =>
        {
            modal.on(ViewEvent.UNLOAD, () => resolve());
            
            this.app.renderPartialView(modal).then(() => 
            {
                this.queue.push(modal);

                if (!this.waitingForNext)
                {
                    this.waitingForNext = true;
                    this.next();
                }
            });
        })
    }
}
